import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';

var _class, _descriptor, _descriptor2;
let ApplicationService = (_class = class ApplicationService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
  }
  // Compatibility getter per content.me
  get content() {
    return {
      me: this.session.me
    };
  }

  // Getter per facilitare l'accesso ai dati utente
  get currentUser() {
    return this.session.me;
  }
  get userOrganization() {
    return this.session.me?.organization;
  }
  get userRole() {
    return this.session.me?.role;
  }
  get userTimeZone() {
    return this.session.me?.time_zone || 'Europe/Rome';
  }
  get optionField() {
    return this.session.option_field;
  }

  // Metodo per creare nuovi modelli (sostituisce newModelMixin)
  async createNewModel(modelName, documentType = null) {
    // This service IS `application` — `this.application` was always undefined,
    // so new records silently missed their organization.
    const organization = this.userOrganization;
    const newModel = this.store.createRecord(modelName);

    // Imposta proprietà di base
    if (organization) {
      newModel.organization = organization;
    }
    if (documentType && modelName === 'invoice') {
      newModel.document_type = documentType;
    }
    return newModel;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ApplicationService as default };
//# sourceMappingURL=application.js.map
